/**
 * @file ErrorBoundary.jsx
 * @location src/components/ErrorBoundary.jsx
 * @role 전역 에러 경계 — 하위 컴포넌트 예외 캐치 후 폴백 UI 표시
 *
 * main.jsx 에서 AppProvider 바깥에 배치되어 Context 초기화 실패도 잡습니다.
 * 에러 발생 시 '재시도' 버튼으로 상태를 초기화 (재마운트 없이 클리어).
 *
 * ErrorBoundary
 * 하위 컴포넌트에서 발생한 예외를 잡아 앱 전체 크래시를 방지합니다.
 */
import { Component } from 'react';
import { captureError } from '../integrations/sentry.js';

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
    captureError(error, { extra: { componentStack: info.componentStack } });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex', flexDirection: 'column', alignItems: 'center',
          justifyContent: 'center', height: '100vh', gap: 12,
          fontFamily: 'inherit', color: 'var(--t1, #333)',
        }}>
          <div style={{ fontSize: 32 }}>⚠️</div>
          <div style={{ fontSize: 16, fontWeight: 600 }}>페이지를 불러오지 못했습니다</div>
          <div style={{ fontSize: 12, color: 'var(--t3, #999)' }}>
            {this.state.error?.message}
          </div>
          <button
            style={{ marginTop: 8, padding: '8px 20px', borderRadius: 'var(--r-md)', border: '1px solid var(--bdm, #ddd)', cursor: 'pointer', fontSize: 13 }}
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            재시도
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
